import type { ImportRowError } from '@paintscout/api'

export interface RowErrorGroup {
  code: string
  /** The server's copy for the code, e.g. "Invalid email". */
  message: string
  /** Row labels in file order, one per row. */
  labels: string[]
}

/**
 * Groups row errors by reason, one group per error code, in the order each code first appears.
 *
 * A row with several codes is listed under each of them. A code repeated within one row (one
 * `VALUE_TOO_LONG` per long cell) lists that row once.
 */
export function groupRowErrors(errors: ImportRowError[]): RowErrorGroup[] {
  const groups = new Map<string, RowErrorGroup>()

  for (const error of errors) {
    const seen = new Set<string>()
    error.codes.forEach((code, i) => {
      if (seen.has(code)) {
        return
      }
      seen.add(code)

      let group = groups.get(code)
      if (!group) {
        group = { code, message: error.messages[i] ?? code, labels: [] }
        groups.set(code, group)
      }
      group.labels.push(error.label)
    })
  }

  return Array.from(groups.values())
}

/** "Avery Fraser, Jordan Fraser, Riley Fraser and 57 more". */
export function formatGroupLabels(labels: string[], max = 3): string {
  const listed = labels.slice(0, max).join(', ')
  const rest = labels.length - max
  return rest > 0 ? `${listed} and ${rest} more` : listed
}
